export default __webpack_public_path__ + "static/media/394.f574ece6.png";